import { IHttpService } from "angular";
import { PagedEntityList, ScheduleEventListResponse } from "@herbjoy/apex-api-models";

/**
 * An enum listing the name values of possible assigned statuses.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ScheduleEventAssignedStatus = {
    Pending: "Pending",
    Accepted: "Accepted",
    Rejected: "Rejected",
    Unassigned: "Unassigned"
};

/**
 * An enum listing the int values of possible assigned statuses.
 */
export const ScheduleEventAssignedStatusEnum = {
    Pending: 1,
    Accepted: 2,
    Rejected: 3,
    Unassigned: 4
};

export class ScheduleEventService {
    constructor(private $http: IHttpService, private apexApiUrl: string) {
        'ngInject'
        this.$http = $http
        this.apexApiUrl = apexApiUrl
    }

    /**
     * Retrieve a list of all the schedule events.
     */
    retrieveScheduleEvents(query) {
        return this.$http.get(this.apexApiUrl + "schedule-events", {
            params: query,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            });
    }

    /**
     * Get assigned schedule events for the office filtered by the query.
     * @param {number} officeID The office whose assigned schedules will be returned
     * @param {any} query The query parameters
     */
    retrieveOfficeAssignedScheduleEvents(officeID, query) {
        return this.$http({
            method: "GET",
            url: `${this.apexApiUrl}/icd-offices/${officeID}/assigned-schedule-events`,
            params: query
        }).then(response => response.data);
    }

    retrieveScheduleEventsPage(pageIndex, query) {
        return this.$http.get<PagedEntityList<ScheduleEventListResponse>>(this.apexApiUrl + "schedule-events/page/" + (pageIndex || 0), {
            params: query,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            });
    }

    /**
    * Retrieve given schedule event.
    */
    retrieveScheduleEvent(scheduleEventID) {
        return this.$http.get(this.apexApiUrl + "schedule-events/" + scheduleEventID, {
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            });
    }


    /**
    * Retrieve recently assigned corporation
    */
    retrieveRecentScheduleCorporations(divisionID) {
        return this.$http.get(this.apexApiUrl + "schedule-events/" + divisionID + "/recent/corporations", {
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            });
    }

    /**
     * Create a new schedule event.
     */
    createScheduleEvent(scheduleEvent) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "schedule-events",
            headers: {
                "Content-Type": "application/json"
            },
            data: JSON.stringify(scheduleEvent)
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Update the given schedule event.
     */
    updateScheduleEvent(scheduleEventID, scheduleEvent) {
        return this.$http({
            method: "PUT",
            url: this.apexApiUrl + "schedule-events/" + scheduleEventID,
            headers: {
                "Content-Type": "application/json"
            },
            data: JSON.stringify(scheduleEvent)
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Patch the given schedule event.
     */
    patchScheduleEvent(scheduleEventID, request) {
        return this.$http({
            method: "PATCH",
            url: `${this.apexApiUrl}/schedule-events/${scheduleEventID}`,
            data: request
        }).then(response => response.data);
    }

    /**
     * Delete the given schedule event.
    */
    deleteScheduleEvent(scheduleEventID) {
        return this.$http({
            method: "DELETE",
            url: this.apexApiUrl + "schedule-events/" + scheduleEventID,
            headers: {
                "Content-Type": "application/json"
            }
        }).then(function (response) {
            return response.data;
        });
    }


    /**
     * Retrieve the evnet scheduling TSU Report rummary.
     */
    retrieveScheduleEventTsuSummaryReport(query) {
        return this.$http.get(this.apexApiUrl + "schedule-events/report/tsu-report-summary", {
            params: query,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            });
    }

    /**
     * Retrieve the evnet scheduling employee TSU report.
     */
    retrieveScheduleEventEmployeeTsuReport(query) {
        return this.$http.get(this.apexApiUrl + "schedule-events/report/employee-tsu-report", {
            params: query,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            });
    }

    updateScheduleEventAdditionalHours(scheduleEventID, request) {
        return this.$http({
            method: "PUT",
            url: this.apexApiUrl + "schedule-events/" + scheduleEventID + "/additional-hours",
            data: request
        }).then(function (response) {
            return response.data;
        });
    }
}
